declare type transformItemFunctionType = (params: {
  originalId: number;
  title: string;
  promoImage: string;
  coverImageUrl: string;
  imagePlaceholder?: string;
  imagePlaceholderUrl?: string;
  url: string;
  professor: string;
  prices: {
    price: number;
    realPrice: number;
    discount: number;
  };
  discount: number;
  nextDiscount: number;
}) => {
  type: string;
  id: string;
  originalId: number;
  title: string;
  url: string;
  image: string;
  imagePlaceholder: string | undefined;
  professor: string;
  price: number;
  realPrice: number;
  discount: number;
  nextDiscount: number;
};

enum TYPE {
  COURSE = 'COURSE',
  BUNDLE = 'BUNDLE',
}

declare type transformItemType = (type: TYPE) => transformItemFunctionType;

export const transformItem: transformItemType = type => ({
  originalId: bundleId,
  title,
  promoImage,
  coverImageUrl,
  url,
  professor,
  prices: pricesNode,
  discount,
  imagePlaceholder,
  imagePlaceholderUrl,
  nextDiscount,
  ...rest
}) => ({
  ...rest,
  type,
  id: `${bundleId}${type}`,
  originalId: bundleId,
  title,
  url,
  image: promoImage || coverImageUrl,
  imagePlaceholder: imagePlaceholder || imagePlaceholderUrl,
  professor,
  discount,
  ...pricesNode,
  prices: pricesNode,
  promoImage,
  nextDiscount,
});

export const parseData = ({
  prices,
  totalDiscount,
  originalId,
  shoppingCartDetailBundlesSet,
  shoppingCartDetailCoursesSet,
  dataExtraDiscount,
  nextDiscount,
  pricesWithCredit,
}) => {
  const courseIdsInCart: number[] = [];

  const courses = shoppingCartDetailCoursesSet.edges
    .map(el => el.node)
    .filter(el => el.prices.price > 0)
    .map(c => {
      courseIdsInCart.push(c.course.originalId);
      return {
        ...c.course,
        categoryName: c.course.categoryObj && c.course.categoryObj.name,
        subcategoryName: c.course.subCategory && c.course.subCategory.name,
        prices: { ...c.prices },
      };
    })
    .map(transformItem(TYPE.COURSE))
    .map(c => {
      const extraDiscountItem = dataExtraDiscount
        ? dataExtraDiscount.find(i => i.id === c.originalId)
        : null;

      return {
        ...c,
        extraDiscount: extraDiscountItem ? extraDiscountItem.percent : null,
      };
    })
    .reverse();

  const bundleIdsInCart: number[] = [];
  const bundles = shoppingCartDetailBundlesSet.edges
    .map(el => el.node)
    .map(b => {
      bundleIdsInCart.push(b.bundle.originalId);
      return { ...b.bundle, prices: { ...b.bundle.prices } };
    })
    .map(transformItem(TYPE.BUNDLE))
    .reverse();

  return {
    nextDiscount,
    cartSummary: {
      idCart: originalId,
      totalOff: totalDiscount,
      dataExtraDiscount,
      currencySymbol: prices.currencySymbol,
      totalPrice: prices.price,
      totalRealPrice: prices.realPrice,
      totalPriceWithCredits: pricesWithCredit.priceWithCredit,
      credit: pricesWithCredit.credit,
    },
    items: [...courses, ...bundles],
    bundles,
    courses,
    courseIdsInCart,
    bundleIdsInCart,
  };
};
